"use client";

import { useEffect } from "react";

const STICKY_NAV_OFFSET = 80;

export default function HashScroller() {
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;

      const element = document.getElementById(hash.substring(1));
      if (!element) return;

      // Delay so the measurement happens after hydration settles the layout
      setTimeout(() => {
        const top =
          element.getBoundingClientRect().top +
          window.scrollY -
          STICKY_NAV_OFFSET;
        window.scrollTo({ top, behavior: "smooth" });
      }, 300);
    };

    scrollToHash();

    window.addEventListener("hashchange", scrollToHash);
    return () => {
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);

  return null;
}
